import { useQuery } from '@apollo/client';
import { MY_SOCIAL_POSTING_PLATFORMS } from '@/queries/queries';
import { isPublishPlatform, type PublishPlatform } from '@/lib/publishing/types';

const DEFAULT_POSTING_PLATFORMS: PublishPlatform[] = ['tiktok', 'youtube', 'instagram'];

/** Platforms the viewer may post to. Facebook appears only when the backend lists
 * it; while loading or on error the three defaults (never Facebook) are returned. */
export function useSocialPostingPlatforms(): PublishPlatform[] {
  const { data, error } = useQuery<{ mySocialPostingPlatforms: string[] }>(
    MY_SOCIAL_POSTING_PLATFORMS,
    // The client is `no-cache` by default; this gate is per account, fetched once per
    // session. The cache entry is evicted on login/logout (resetAccountScopedCache).
    { fetchPolicy: 'cache-first' },
  );
  const listed = data?.mySocialPostingPlatforms;
  if (error || !Array.isArray(listed)) return DEFAULT_POSTING_PLATFORMS;
  return listed.filter(isPublishPlatform);
}
